var isDefined = {exports: {}};

export { isDefined as __module };
